export const fengEnv = {
  production: false,
  maintenance: false,
  apiURL: 'https://api.dev.novogigante.feng.rocks/',
  apiURLV2: 'https://api.dev.novogigante.feng.rocks/v2/',
  // apiURL: 'http://localhost:4000/',
  weURL: 'https://admin.stg.sociogigante.com/',
  recaptcha: {
    key: '6LdiqAkfAAAAAISRQLSkAjRInAAHr1JEW64FIP61'
  },
  auth: {
    new: true,
    social: [
      { name: 'google', provider: '385980807876-eefakt2o60ti35lurhvu2ubhc2f0l3vu.apps.googleusercontent.com' },
      { name: 'facebook', provider: '1027045667898738' }
    ],
    cognito: {
      enable: false,
      REGION: 'us-east-1',
      USER_POOL_ID: '',
      APP_CLIENT_ID: '',
      API_APP_KEY: ''
    },
    fanbase: {
      enable: true,
      hybrid: false,
      name: 'VASCO-ID',
      image: 'https://config.fanbase.com.br/fanpage/297/img/logo-id.png',
      authorize_url: `https://login-vasco.fantest.com.br/authorize?response_type=code&scope=openid&client_id=297feng&redirect_uri=https%3A%2F%2Fdev.novogigante.feng.rocks%2Fsso`,
      account_url: 'http://account.vascoid.com.br/',
      exclusive_auth_modal_content: `
        <p>Olá, torcedor vascaíno!<br>Agora o acesso ao Sócio Gigante é feito com o Vasco ID, a conta única para todos os serviços do clube.</p>
        <p class="fanbase-content__action"><strong>Já tem cadastro no Sócio Gigante?</strong><br><a href="https://login-vasco.fantest.com.br/authorize?response_type=code&scope=openid&client_id=297feng&redirect_uri=https%3A%2F%2Fdev.novogigante.feng.rocks%2Fsso"><button class="feng-btn">Entre com o mesmo login e senha</button></a>.</p>
        <p class="fanbase-content__action"><strong>Não lembra sua senha?</strong><br><a id="fanbase-forgot-pass"><button class="feng-btn">Clique aqui, siga os passos e faça seu login</button></a>.</p>
        <p class="fanbase-content__action"><strong>Ainda não tem cadastro?</strong><br><a href="https://login-vasco.fantest.com.br/authorize?response_type=code&scope=openid&client_id=297feng&redirect_uri=https%3A%2F%2Fdev.novogigante.feng.rocks%2Fsso"><button class="feng-btn">Crie seu Vasco ID para acessar</button></a>.</p>
        <div class="log-horizontal-divider"></div>
        <p>Dúvidas? Fale com a gente: <a href="mailto:suporte@vascoid.com.br">suporte@vascoid.com.br</a></p>
      `,
    }
  }
};
